import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types'

// Firebase (Google Cloud)
import { auth as firebase_auth } from '../../config/firebase-config';
import { signOut } from 'firebase/auth';

// Redux
import { connect } from 'react-redux';

// Actions
import { logout, changePassword } from '../../actions/authActions';
import { setAlert } from '../../actions/alertActions';

// Components
import DefaultAvatar from 'react-avatar';
import Alert from '../common/Alert';

// Icons
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Config_Block from './Config_Block';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

// Initial State
const initialState = {
    password: '',
    confirmPassword: ''
}
  
const Account_Settings = ({
    auth,
    logout,
    setAlert,
    alerts,
    changePassword
}) =>  {

    // State for form data
    const [formData, setFormData] = useState(initialState);

    const [toggle_changePassword, setToggle_ChangePassword] = useState(false);

    const [processing, setProcessing] = useState(false);

    // Load user data
    useEffect(() => {
        if (!auth.loading && auth.user) {
        // Create a copy of the initial form data with user values
        const userData = { ...initialState };
        for (const key in auth.user) {
            if (key in userData) userData[key] = auth.user[key];
        }
        // Clear password fields
        userData.password = '';
        userData.confirmPassword = '';

        setFormData(userData);
        }
    }, [auth.user]);

    // Destructure the email value from form data
    const { password, confirmPassword } = formData;

    // Function to handle input change
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

    const toggleInputs = () => {
        if(toggle_changePassword) {
            setFormData(initialState);
        } 

        setToggle_ChangePassword(!toggle_changePassword);
    }

    const onSubmitPassword = async e => {
      e.preventDefault();

      if(auth.user) {
        const userId = auth.user_id; 

        if(password === '') {
            setAlert('Please enter a new password', 'danger');
        } else if(confirmPassword === '') {
            setAlert('Must re-enter new password', 'danger');
        } else if(password !== confirmPassword) {
            setAlert('Passwords do not match', 'danger');
        } else {
            changePassword({ 
                password
            });

            setFormData(initialState);
        }
      }
    }

    const handleLogout = async () => {
        setProcessing(true);
        try {
        
            // Sign out the user with firebase hook
            await signOut(firebase_auth);
    
            // Dispatch the LOGOUT action to clear the user data from the Redux store
            logout();
        } catch (err) {
            console.log('Error logging out', err);
        } finally {
            setProcessing(false);
        }
    }

	return (
        <Fragment>
        {/* Account  */}
        <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '3rem'}}>
          <div>
            <DefaultAvatar name={"t"} size="40" round={true} />
          </div>
          <h2 style={{fontWeight: 'bold', fontSize: '1.5rem', color: '#fff'}}>
            Settings
          </h2>
        </div>

        {auth.isPremium && <Config_Block />}

        <div>
          <h3 style={{marginBottom: '1.5rem', fontSize: '1.25rem', color: '#fff'}}>
            Account Details
          </h3>
          <div>
            <label style={{color: 'rgb(152,152,152)', fontSize: '15px', fontWeight: 500}}>
              Email
            </label>
            <div style={{background: 'rgb(26,26,26)', color:'#fff', fontSize: '15px', padding: '.875rem 1rem', margin: '.625rem 0', borderRadius: '.75rem'}}>
              {auth.user?.email}
            </div>
          </div>
          <div style={{margin: '1.25rem 0', display:`${toggle_changePassword ? 'block' : 'none'}`}}>
            {/* Alert */}
            {alerts?.length > 0 && (
              <Alert />
            )}
            {/* Input fields */}
            <div className='register_form_inputs'>
                                
                {/* Input & Label */}
                <div className='register_input_container login'>
                    <label for="password" className='register_input_label login'>
                      New Password
                    </label>
                    <input 
                        type="password"
                        placeholder="Enter new password"
                        className="input"
                        name="password"
                        value={password}
                        maxlength="30"
                        onChange={e => onChange(e)}
                    />
                </div>

                {/* Password*/}
                <div className='register_input_container login'>
                    <label for="confirmPassword" className='register_input_label login'>
                      Confirm New Password
                    </label>
                    <input 
                        type="password"
                        placeholder="Confirm new password"
                        className="input"
                        name="confirmPassword"
                        value={confirmPassword}
                        maxlength="30"
                        onChange={e => onChange(e)}
                    />
                </div>
            </div>

            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '1rem 0'}}>
              <div onClick={toggleInputs} style={{color: 'rgb(152,152,152)', fontSize: '15px', fontWeight: 500, padding: '.5rem 1rem', cursor: 'pointer'}}>
                Cancel
              </div>
              <div onClick={onSubmitPassword} style={{background: '#fff', color: '#000', fontSize: '15px', fontWeight: 500, padding: '.5rem 1rem', borderRadius: '.75rem', cursor: 'pointer'}}>
                Save Changes
              </div>
            </div>
          </div>
          <div onClick={toggleInputs} style={{color: 'rgb(152,152,152)', fontSize: '15px', fontWeight: 500, padding: '.5rem 1rem', cursor: 'pointer', display: 'flex', gap: '.5rem', alignItems: 'center'}}>
            <LockOutlinedIcon />
            Change Password
          </div>
          <div onClick={!processing ? handleLogout : null} style={{color: 'rgb(248,113,113)', fontSize: '15px', fontWeight: 500, padding: '.5rem 1rem', cursor: 'pointer', display: 'flex', gap: '.5rem', alignItems: 'center'}}>
            <LogoutOutlinedIcon />
            {!processing ? 'Log Out' : 'Signing off...'}
          </div>
        </div>
        {/* End: Account */}
      </Fragment>
	);
}
  
Account_Settings.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    alerts: PropTypes.func.isRequired,
    changePassword: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    // Mapping the authentication state
    auth: state.auth,
    alerts: state.alert,
});

export default connect(mapStateToProps, { 
    // Connecting actions to the component
    logout,
    setAlert,
    changePassword
})(Account_Settings);
  